import React, { Suspense, lazy } from "react";
import { CircularProgress, Box } from "@mui/material";

import { OfficeLoginPage, SsoLoginPage } from "@pages";

const DMSurveyPage = lazy(() => import("../../pages/dm-survey/DMSurveyPage"));

const LoadingFallback = (): React.ReactElement => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}
  >
    <CircularProgress />
  </Box>
);

export const publicRoutes = [
  {
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <DMSurveyPage />
      </Suspense>
    ),
    path: "dm-survey/:stakeholderId",
  },
  {
    element: <OfficeLoginPage />,
    path: "office-login",
  },
  {
    element: <SsoLoginPage />,
    path: "sso-login",
  },
];
